// removed by extract-text-webpack-plugin
module.exports = {"Button":"_3YXtu9Ff4Fr-aaEtcIOtKA","green":"_320FKsnvUnvE-YbDitWsIF","orange":"_2vWOQ_O1l5x9LK4myevzu3","grey":"_2-f1tj--jkYY5T0Ct4udPg","greyblue":"_3ynuqwpQpYYZ4L11wA9dC_","darkgreywhite":"_276nfPiAthfbXSe_ZICMW-","darkbluewhite":"_3q-RynqXrelsOl5SE9DssG","fullWidth":"Zrbbkg0UN8-xTmPIZ5OiS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/Button/index.css
// module id = 657
// module chunks = 0